export class PropertyLedger {
}
PropertyLedger.RegisteredControls = {};
//# sourceMappingURL=propertyLedger.js.map